module.exports = __webpack_public_path__ + "155cd1cfec436b5633ad08c68171d2ac.svg";